import { NgModule } from '@angular/core';

import { AddCommasPipe } from './add-commas.pipe';
import { EllipsisPipe } from './ellipsis.pipe';
import { EnumListPipe } from './enum-list.pipe';
import { DateToUtcPipe } from './date-to-utc.pipe';


export const PIPES = [AddCommasPipe, EllipsisPipe, EnumListPipe, DateToUtcPipe];

@NgModule({
  declarations: PIPES,
  exports: PIPES,
})
export class PipesModule {
}



// WEBPACK FOOTER //
// ./src/app/common/pipes/index.ts